import React from 'react';

const IntegrationSection = () => (
  <section id="soluciones" className="w-full py-12 md:py-24 lg:py-32">
    <div className="container px-4 md:px-6">
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-20">
        <div className="space-y-4">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900 dark:text-gray-100">
            Integración Tecnológica Sin Límites
          </h2>
          <p className="text-gray-600 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
            Nuestras soluciones de integración avanzada garantizan que la información fluya de manera masiva y segura entre tus sistemas y los nuestros, optimizando la visibilidad y la toma de decisiones en tiempo real.
          </p>
          <div className="space-y-4">
            {[
              {
                title: "Carpetas FTP",
                description: "Transferencia segura de archivos mediante protocolos cifrados."
              },
              {
                title: "Conexión por URL",
                description: "Acceso remoto a información en tiempo real mediante APIs."
              },
              {
                title: "Layouts Personalizados",
                description: "Plantillas de Excel predefinidas para carga masiva de datos."
              }
            ].map((feature, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="mt-1 flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 dark:bg-indigo-800">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 dark:text-gray-100">{feature.title}</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full rounded-xl border border-gray-300 bg-gray-200 p-8 dark:border-gray-700 dark:bg-gray-800">
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <div className="h-2 w-2 rounded-full bg-teal-500"></div>
                <div className="h-2 w-16 rounded-full bg-indigo-300 dark:bg-indigo-700"></div>
                <div className="h-2 w-8 rounded-full bg-indigo-300 dark:bg-indigo-700"></div>
              </div>
              <div className="space-y-2">
                <div className="h-2 w-full rounded-full bg-indigo-300 dark:bg-indigo-700"></div>
                <div className="h-2 w-3/4 rounded-full bg-indigo-300 dark:bg-indigo-700"></div>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-8 w-8 rounded bg-indigo-300 dark:bg-indigo-700"></div>
                <div className="h-2 w-16 rounded-full bg-indigo-300 dark:bg-indigo-700"></div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="h-20 rounded bg-indigo-300 dark:bg-indigo-700"></div>
                <div className="h-20 rounded bg-indigo-300 dark:bg-indigo-700"></div>
                <div className="h-20 rounded bg-indigo-300 dark:bg-indigo-700"></div>
              </div>
              <div className="h-8 w-full rounded bg-indigo-300 dark:bg-indigo-700"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default IntegrationSection;